module.exports = __webpack_public_path__ + "img/baizhi-back-three@3x.a507907c.png";